// extracted by mini-css-extract-plugin
export default {"scope":"ervKX","icon":"qxtyU"};